module.exports = __webpack_public_path__ + "static/media/micro-instrumental.bb594136.svg";